module.exports = __webpack_public_path__ + "images/emoji/articulated_lorry.617d7ea476a35f2c6e03.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/articulated_lorry.png
// module id = IuHs
// module chunks = 1